<template>
	<v-card>
		<egranty-table
			:table-name="'Typy projektów'"
			:items="contestProjectTypes"
			:headers="headers"
			:export-enabled="true"
			:row-actions="actions"
			:toolbar-action-name="'Dodaj typ'"
			@toolbarAction="addProjectTypeDialog = true"
			@deleteType="deleteType"
		></egranty-table>
		<v-dialog v-model="addProjectTypeDialog" max-width="500px">
			<v-card>
				<v-card-title>
					<span class="headline">Nowy typ</span>
				</v-card-title>
				<v-card-text>
					<v-select
						v-model="chosenProjectType"
						:items="dictionaryProjectTypes"
						label="Typ projektu"
						aria-label="project type"
						for="agency-contest-type-table-type-project"
						id="agency-contest-type-table-type-project"
						item-text="type"
						item-value="id"
					></v-select>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="addProjectTypeDialog = false">Anuluj</v-btn>
					<v-btn :disabled="chosenProjectType === null" color="primary" @click="addType()">Zapisz
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import EgrantyTable from "../../../../genericComponents/EgrantyTable";
	import {AgencyContest} from "../../../../api/generated/AgencyContest";
	import {AgencyProjectType} from "../../../../api/generated/AgencyProjectType";

	export default {
		name: "AgencyContestTypeTable",
		components: {EgrantyTable},

		data () {
			return {
				addProjectTypeDialog: false,
				chosenProjectType: null,
				contestProjectTypes: [],
				dictionaryProjectTypes: [],
				headers: [
					{text: "Typ", value: "type"}
				],
				actions: [
					{name: "deleteType", icon: "delete"}
				],
			};
		},

		methods: {
			addType () {
				addProjectType(this);
			},

			deleteType (item) {
				this.$confirm("Czy na pewno chcesz usunąć typ projektu?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie typu projektu",
					width: 500
				})
					.then(result => {
						if (result) {
							deleteProjectType(this, item.id);
						}
					});
			},

			refresh () {
				getProjectTypes(this);
			}
		},

		watch: {
			addProjectTypeDialog: function (value) {
				!value && (this.chosenProjectType = null);
			}
		},

		created () {
			this.refresh();
		}
	};

	function getProjectTypes (ctx) {
		AgencyContest.getProjectTypes(ctx, ctx.$route.params.id, successResponse => {
				ctx.contestProjectTypes = successResponse;
				getProjectTypesDictionaryList(ctx);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować typów projektów", errorResponse);
			});
	}

	function addProjectType (ctx) {
		AgencyContest.postProjectType(ctx, ctx.$route.params.id, ctx.chosenProjectType, successResponse => {
				ctx.$messagesBus.$emit("success", "Typ projektu został pomyślnie dodany", successResponse);
				ctx.addProjectTypeDialog = false;
				ctx.refresh();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się dodać typu projektu", errorResponse);
			});
	}

	function deleteProjectType (ctx, projectTypeId) {
		AgencyContest.deleteProjectType(ctx, ctx.$route.params.id, projectTypeId, successResponse => {
				ctx.$messagesBus.$emit("success", "Typ projektu został usunięty", successResponse);
				ctx.refresh();
			},
			errorResponse => {
				const fallbackMessage = "Nie udało się usunąć typu projektu. Typ projektu może być już użyty w złożonym wniosku.";
				ctx.$messagesBus.$emit("error", errorResponse && errorResponse.message ? errorResponse.message : fallbackMessage, errorResponse);
			});
	}

	function getProjectTypesDictionaryList (ctx) {
		AgencyProjectType.get(ctx, successResponse => {
				ctx.dictionaryProjectTypes = successResponse.filter(item => !ctx.contestProjectTypes.map(type => type.id).includes(item.id));
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się pobrać listy typów projektów", errorResponse);
			});
	}

</script>

<style scoped>

</style>
